"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "paceco": {
    "0a498448": [{
      "hkey": "55b30e4e",
      "slug": "paceco",
      "name": "Paceco",
      "primary": true,
      "skipSearch": false
    }],
    "dattilo": [{
      "hkey": "55b30e4e",
      "slug": "paceco",
      "name": "Paceco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e927e0c3": [{
      "hkey": "55b30e4e",
      "slug": "paceco",
      "name": "Paceco",
      "primary": true,
      "skipSearch": false
    }],
    "nubia": [{
      "hkey": "55b30e4e",
      "slug": "paceco",
      "name": "Paceco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;